<script setup>
import { defineProps, computed } from 'vue';
import CartaoTabelaBase from '@/components/v2/base/CartaoTabelaBase/CartaoTabelaBase.vue';

const props = defineProps({
    osFilhas: { type: Array, default: () => [] },
});

const headers = [
    { text: 'Código', value: 'codigo', width: '120px' },
    { text: 'Descrição', value: 'descricao', width: 'minmax(260px, 1fr)' },
    { text: 'Tipo', value: 'osTipo', width: '160px' },
    { text: 'Coordenador de Projetos', value: 'coordenadorDeProjetosNome', width: '220px' },
];

const dadosTabela = computed(() => (
    Array.isArray(props.osFilhas)
        ? props.osFilhas.map((item = {}, index) => ({
            id: item?.id || item?._id || `os-filha-${index}`,
            codigo: item?.codigo || '',
            descricao: item?.descricao || '',
            osTipo: item?.osTipo || '',
            coordenadorDeProjetosNome: item?.coordenadorDeProjetosNome || '',
        }))
        : []
));
</script>

<template>
    <CartaoTabelaBase
        v-if="dadosTabela.length > 0"
        class="c-os-filhas"
        :headers="headers"
        :dados="dadosTabela"
        :disabled="true"
    >
        <template #header>
            <span class="text-subtitle-1 font-weight-bold">OS Filhas</span>
        </template>
    </CartaoTabelaBase>
</template>

<style scoped>
.c-os-filhas {
    margin-top: 8px;
}

.c-os-filhas :deep(.c-card) {
    padding: 8px;
    gap: 8px;
}

.c-os-filhas :deep(.c-tabela__wrapper) {
    max-height: 240px;
}

.c-os-filhas :deep(.c-tabela) {
    min-inline-size: 100%;
}
</style>
